<div class="position-absolute h-auto custom-w-30 m-auto center-div selezionaOggetti">
  <div class="overflow-box">
    <div
      class="bg-dark text-white p-2 custom-font"
      *ngFor="let oggettoSelezionato of oggettiSelezionati"
    >
      <label>{{ oggettoSelezionato.getProperties().name }}</label>
      <div class="float-right">
        <fa-icon
          class="px-1"
          placement="top"
          ngbTooltip="Info"
          (click)="viewInfoSelectedObject(oggettoSelezionato)"
          [icon]="faInfoCircle"
        >
        </fa-icon>
        <!-- <fa-icon
          class="px-1"
          placement="top"
          ngbTooltip="Modifica"
          (click)="modifySelectedObject(oggettoSelezionato)"
          [icon]="faEdit"
        >
        </fa-icon> -->
        <fa-icon
          class="px-1"
          placement="top"
          ngbTooltip="Chiudi"
          (click)="closeSelectedObject(oggettoSelezionato)"
          [icon]="faTimesCircle"
        >
        </fa-icon>
      </div>
    </div>
  </div>
</div>
